import { Ref } from 'vue';
import { updateMultiple } from '@/ui/queryState';
import { PaginationResetCallback } from '@/ui/types';
import { inputField } from '../form';

export const textFilter = ({
  value,
  name,
  label,
  placeholder,
  reset,
  hideLabel,
  horizontal,
  icon,
}: {
  value: Ref<string>;
  name: string;
  label: string;
  placeholder: string;
  reset: PaginationResetCallback;
  hideLabel?: boolean;
  horizontal?: boolean;
  icon?: string | undefined;
}) => inputField(
  {
    value: value.value,
    name,
    label,
    placeholder,
    required: false,
    errors: [],
    disabled: false,
    hideLabel,
    horizontal,
    icon,
  },

  v => updateMultiple(() => {
    reset();
    value.value = v;
  }, true),
);
